module.exports = __webpack_public_path__ + "dc589653.png";